import styled from '@emotion/styled';
import { Alert as MuiAlert, Snackbar } from '@mui/material';

interface IAlertProps {
    severity: 'error' | 'success' | 'warning';
    message: string;
}

export default function Alert({ severity, message }: IAlertProps) {
    if (message === '') return null;
    return (
        <ToolbarSnackbar
            open={true}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <MuiAlert severity={severity} sx={{ width: '100%' }}>
                {message}
            </MuiAlert>
        </ToolbarSnackbar>
    );
}

const ToolbarSnackbar = styled(Snackbar)`
    margin-top: 52px;
`;
